import { Source81 } from 'analytic-events/MI/services/BannerWidgetService/events/Source81';

export enum MiBannerAnalyticsSource {
  B2B_PROFILE = 'b2b_profile',
  CATALOG_1 = 'catalog_1',
  CATALOG_2 = 'catalog_2',
  DISCOVERY_CLUB = 'discovery_club',
  LENTA_BAR = 'lenta_bar',
  LISTING = 'listing',
  MAIN_PAGE = 'main_page',
  PROMOACTION = 'promoaction',
  SEARCH = 'search',
  ZOO = 'zoo',
}

export type MiBannerAnalyticsSourceValue = Source81;
